import type { ReactNode } from "react";

export function FilterCard({
  className = "",
  disabled = false,
  children,
}: {
  className?: string;
  disabled?: boolean;
  children: ReactNode;
}) {
  return (
    <div
      className={`flex flex-col items-start gap-1 rounded-sm border border-grey-200 p-3 ${disabled ? "bg-grey-50" : "bg-white shadow-flat"} ${className}`}
    >
      {children}
    </div>
  );
}

export function FilterLabel({
  children,
  size = "tiny",
}: {
  children: ReactNode;
  size?: "tiny" | "small";
}) {
  return (
    <p className={`${size === "small" ? "text-small" : "text-tiny"} font-medium text-grey-900`}>
      {children}
    </p>
  );
}
